export default __webpack_public_path__ + "static/media/assetAvax.44b17794.png";